// @ts-nocheck
import siteMessage from "@insite/client-framework/SiteMessage";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography from "@insite/mobius/Typography";
// import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
import React, { FC } from "react";

/* Store Custom Code - Start */
import InfosBox from "@store/Library/Components/Toolkit/InfosBox";
/* Store Custom Code - End */

const enum fields {
    message = "message",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.message]: string;
    };
}

const RequisitionConfirmationConfirmationMessage: FC<OwnProps> = ({ fields }) => {
    return (
        <InfosBox type="success" size="small">
            <Typography>{fields.message || siteMessage("Requisition_Submitted")}</Typography>
        </InfosBox>
    );
};

const widgetModule: WidgetModule = {
    component: RequisitionConfirmationConfirmationMessage,
    definition: {
        group: "Requisition Confirmation",
        allowedContexts: ["RequisitionConfirmationPage"],
        displayName: "Page Container",
        fieldDefinitions: [
            {
                name: fields.message,
                displayName: "Success Message",
                editorTemplate: "TextField",
                fieldType: "Translatable",
                defaultValue: "Your requisition has been submitted for approval",
            },
        ],
    },
};

export default widgetModule;
